__turbopack_context__.v({
  "donorcount": "ResultsHeadline-module-scss-module__z9GwRa__donorcount",
  "lastupdated": "ResultsHeadline-module-scss-module__z9GwRa__lastupdated",
  "outputs": "ResultsHeadline-module-scss-module__z9GwRa__outputs",
  "subheader": "ResultsHeadline-module-scss-module__z9GwRa__subheader",
  "wrapper": "ResultsHeadline-module-scss-module__z9GwRa__wrapper",
});
